/* -----------------Types--------------- */
import type { Plan } from "@memorang/types";

/* -----------------Child components--------------- */
import MarkdownRenderer from "@memorang/ui/components/MarkdownRenderer";
import pluralize from "pluralize";
import { getSubscriptionIntervalText } from "../../helpers/purchase";

type RecommendedPlanTextProps = {
	recommendedPlan: Plan;
	selectedDate?: string;
	isSubscriptionEnabled?: boolean;
};
const RecommendedPlanText = ({
	recommendedPlan,
	selectedDate,
	isSubscriptionEnabled,
}: RecommendedPlanTextProps) => {
	const subscriptionText = getSubscriptionIntervalText(
		recommendedPlan.interval,
		recommendedPlan.duration,
		false,
	);

	const text = isSubscriptionEnabled
		? `We recommend the **${subscriptionText} subscription** for continuous access and preparation for your exam on\n\n**${selectedDate}**`
		: `We recommend the "**${recommendedPlan.duration} ${pluralize(recommendedPlan.interval, recommendedPlan.duration)}**" plan to best prepare for your exam on\n\n**${selectedDate}**`;
	return <MarkdownRenderer text={text} textAlign="center" />;
};
export default RecommendedPlanText;
